// Call only after a browser mount. Gatsby SSR must not execute window-based canvas modules.
let loading;
export function ensureVendors(){
 if(typeof window==='undefined')return Promise.reject(new Error('BROWSER_REQUIRED'));
 if(!loading)loading=import('./visual/mobile-canvas-compat.js')
  .then(()=>Promise.all([import('./visual/assets-loader.js'),import('./visual/card-renderer.js'),import('./visual/peel-gesture.js'),import('./visual/reveal-effects.js'),import('./visual/opening-audio.js')]))
  .then(parts=>{window.OPPeelGesture=parts[2].default||parts[2];})
  .catch(error=>{loading=null;throw error;});
 return loading;
}
